import { parseJwt } from "@connect/post-message/jwt";
import * as z from "zod/mini";
import type {
  GuestCheckoutLimitUpgradeTokenPayload,
  QuoteAmountAsset,
} from "./challenge-token.types";

const nonEmptyString = z.string().check(z.minLength(1));

const limitUpgradeTokenClaims = {
  type: z.literal("guest_checkout_limit_upgrade"),
  quoteSignature: nonEmptyString,
  iat: z.optional(z.number()),
  exp: z.optional(z.number()),
};

const limitUpgradeTokenSchema = z.union([
  z.looseObject({ ...limitUpgradeTokenClaims, iss: z.literal("dev-platform") }),
  z.looseObject({ ...limitUpgradeTokenClaims, issuer: z.literal("dev-platform") }),
]);

// The challenge token embeds the quote's own signature (same JWT signed for
// `/platform/v1/widget/url`) rather than duplicating amount/asset as claims.
// Only the fiat source side is relevant here - eligibility is checked against
// spend amount, not the destination asset being purchased.
const quoteAmountAssetSchema = z.looseObject({
  source: z.looseObject({
    amount: nonEmptyString,
    asset: z.looseObject({ code: nonEmptyString }),
  }),
});

export function decodeChallengeToken(token: string): GuestCheckoutLimitUpgradeTokenPayload | null {
  const payload = parseJwt(token);
  const result = z.safeParse(limitUpgradeTokenSchema, payload);
  return result.success ? result.data : null;
}

export function decodeQuoteAmountAsset(quoteSignature: string): QuoteAmountAsset | null {
  const result = z.safeParse(quoteAmountAssetSchema, parseJwt(quoteSignature));
  return result.success ? result.data.source : null;
}
